import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabIIIB as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabIIIB = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const highSchoolNonSeniorField = () => {
    const propertyName = pn<AprResponseModel>("highSchoolNonSenior");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.highSchoolNonSenior} {formatPercentTotal(props.data?.highSchoolNonSenior, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const highSchoolSeniorField = () => {
    const propertyName = pn<AprResponseModel>("highSchoolSenior");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.highSchoolSenior} {formatPercentTotal(props.data?.highSchoolSenior, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const secondarySchoolDropoutField = () => {
    const propertyName = pn<AprResponseModel>("secondarySchoolDropout");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.secondarySchoolDropout} {formatPercentTotal(props.data?.secondarySchoolDropout, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const otherParticipantUnderField = () => {
    const propertyName = pn<AprResponseModel>("otherParticipantUnder");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.otherParticipantUnder} {formatPercentTotal(props.data?.otherParticipantUnder, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">
          Educational Status of Secondary School-Age Students (at time of first service in the reporting year)   
        </Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              {props.data?.highSchoolNonSenior != null && (
                <Grid item xs={12}>
                  {highSchoolNonSeniorField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.highSchoolSenior != null && (
                <Grid item xs={12}>
                  {highSchoolSeniorField()}
                </Grid>
              )}

              {props.data?.secondarySchoolDropout != null && (
                <Grid item xs={12}>
                  {secondarySchoolDropoutField()}
                </Grid>
              )}

              {props.data?.otherParticipantUnder != null && (
                <Grid item xs={12}>
                  {otherParticipantUnderField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
